import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import TableContainer from '@material-ui/core/TableContainer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepperComponent from './FinancialModel/Stepper';
import OrdersSavedTable from './OrdersSavedTable';
import OrdersSentTable from './OrdersSentTable';
import AmendModal from './AmendModal';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0'
  },
  tableContainer: {
    margin: '35px auto',
    borderTop: '5px solid #2DB9C4'
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '3px solid #d8d8d885',
    '& p': {
      marginLeft: 20,
      fontSize: 12
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  stepper: {
    background: 'transparent'
  },
  text: {
    fontSize: 15
  },
  title: {
    fontWeight: 'bold'
  },
  titleInfo: {
    fontSize: 15,
    fontWeight: 'bold'
  },
  criteriaContainer: {
    margin: '35px auto',
    '& h4': {
      textDecoration: 'underline',
      marginBottom: 25
    }
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  rightButtons: {
    display: 'flex',
    alignItems: 'center'
  },

  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '145px',
    marginLeft: '30px'
  }
}));

const Invest = () => {
  const [ordersSaved, setOrdersSaved] = useState([]);
  const [ordersSent, setOrdersSent] = useState([]);
  const [amendModal, setAmendModal] = useState(false);
  const classes = useStyles();

  const sendOrder = (order) => {
    setOrdersSent([...ordersSent, order]);
    console.log(order);
  };

  const saveOrder = (order) => {
    setOrdersSaved([...ordersSaved, order]);
  };

  const onClickDelete = (order) => {
    if (order.sent === false) {
      setOrdersSaved(ordersSaved.filter((ord) => ord.name !== order.name));
    } else {
      setOrdersSent(ordersSent.filter((ord) => ord.name !== order.name));
    }
  };

  return (
    <>
      <AmendModal open={amendModal} onClose={() => setAmendModal(false)} />
      <Typography className={classes.title} gutterBottom variant="h3">
        Invest in the capital raising
      </Typography>
      <br />
      <Typography className={classes.text} gutterBottom variant="body1">
        Issuer intend to incentivize investors that demonstrate strong interest
        in the asset as well as intention to invest on a long term basis. Thanks
        to technology provided bu Praexo, the deal will be allocated based on an
        algorithm that will apply defined rules.
      </Typography>
      <br />
      <Typography className={classes.text} variant="body1">
        Respect of such a process will be certified by blockchain technology.
      </Typography>
      <Typography className={classes.titleInfo} gutterBottom variant="h6">
        Issuer may amend the allocation determined by the algorithm in the limit
        of 10% of the total targeted amount.
      </Typography>
      <div className={classes.criteriaContainer}>
        <Typography gutterBottom variant="h4">
          Objective criteria used by algorithm
        </Typography>
        <Stepper classes={{ root: classes.stepper }} alternativeLabel>
          <Step active>
            <StepLabel>Nature of investors</StepLabel>
          </Step>
          <Step active>
            <StepLabel>
              Feedbacks given <br /> (date and quality of content)
            </StepLabel>
          </Step>
          <Step active>
            <StepLabel>Positions in similar companies</StepLabel>
          </Step>
          <Step active>
            <StepLabel>
              Deal leadership on price and timing into the book
            </StepLabel>
          </Step>
        </Stepper>
      </div>

      {/* <div className={classes.container}>
        <SelectComponent selectScenario={fetchData} />
      </div> */}
      <TableContainer className={classes.tableContainer} component={Paper}>
        <div className={classes.header}>
          <h2>PLACE AN ORDER</h2>
        </div>
        <StepperComponent sendOrder={sendOrder} saveOrder={saveOrder} />
      </TableContainer>
      <br />
      <TableContainer className={classes.tableContainer} component={Paper}>
        <div className={classes.header}>
          <h2>SAVED ORDERS</h2>
        </div>
        {ordersSaved.length > 0 && (
          <OrdersSavedTable
            orders={ordersSaved}
            onClickDelete={onClickDelete}
            onClickAmend={() => setAmendModal(true)}
          />
        )}
      </TableContainer>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <div className={classes.header}>
          <h2>CONFIRMED ORDER IN THE BOOK</h2>
        </div>
        {ordersSent.length > 0 && (
          <OrdersSentTable
            orders={ordersSent}
            onClickDelete={onClickDelete}
            onClickAmend={() => setAmendModal(true)}
          />
        )}
      </TableContainer>
      <div className={classes.buttonDiv}>
        <div className={classes.rightButtons}>
          <Button
            className={classes.send}
            color="primary"
            variant="contained"
            onClick={() => {}}>
            send to issuer
          </Button>
        </div>
      </div>
    </>
  );
};

export default Invest;
